import { useSidebar } from "ui/components/sidebar";
import { Icon } from "components";
import { PERFORMANCE } from "icons";
import { useQuad } from "./context";
import { StatusDisplay } from "@/components/status/display";

export function CollapsiblePerformanceHeader({ className = "" }) {
    const { state } = useSidebar();
    const isCollapsed = state === "collapsed";
    const { quad, isLoading } = useQuad();

    if (isLoading) {
        return null;
    }

    return (
        <div className="flex flex-col gap-2" {...className}>
            <div className="flex items-center gap-2">
                {isCollapsed && <Icon icon={PERFORMANCE} size={16} />}
                {!isCollapsed && (
                    <div className="flex flex-col gap-2 transition-all duration-200">
                        <h2 className="font-semibold text-lg">
                            {quad?.name || "Performance"}
                        </h2>
                        <StatusDisplay value={quad?.status} />
                    </div>
                )}
            </div>
        </div>
    );
}
